import { render, staticRenderFns } from "./appScore.vue?vue&type=template&id=3c7dd35d&"
import script from "./appScore.vue?vue&type=script&lang=js&"
export * from "./appScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports